/* unplugin-vue-components disabled */import { render } from "./exam-Reading.vue?vue&type=template&id=e31c1d5e&scoped=true"
import script from "./exam-Reading.vue?vue&type=script&lang=js"
export * from "./exam-Reading.vue?vue&type=script&lang=js"

import "./exam-Reading.vue?vue&type=style&index=0&id=e31c1d5e&lang=less"
import "./exam-Reading.vue?vue&type=style&index=1&id=e31c1d5e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31c1d5e"]])

export default __exports__